// providerDisplayName v0.1.0
// Short display labels for cramped dashboard cards. Keep the full provider
// name in titles/aria-labels; this only improves scanability in dense lists.
const SHORT_NAMES: Record<string, string> = {
  aws: 'AWS',
  'google-workspace': 'Google Workspace',
  gcp: 'Google Cloud',
  microsoft365: 'Microsoft 365',
};

const SHORT_NAMES_BY_NAME: Record<string, string> = {
  'Amazon Web Services': 'AWS',
  'Google Cloud Platform': 'Google Cloud',
};

export function providerDisplayName(slug: string, name: string): string {
  return SHORT_NAMES[slug] ?? SHORT_NAMES_BY_NAME[name] ?? name;
}
